import React from 'react';
import PropTypes from 'prop-types';
import PropagateLoader from 'react-spinners/PropagateLoader';

const defaultInnerSpinner = () => (
  <PropagateLoader size={20} loading color="#3989E3" />
);

const LoaderWithMessage = ({ wrapperClassName, messageClassName, InnerSpinner, message }) => (
  <div className={`flex flex-col items-center justify-center ${wrapperClassName}`}>
    <InnerSpinner />
    {message ? (
      <div className={`mt-10 text-sm text-slate-500 text-center ${messageClassName}`}>
        { message }
      </div>
    ) : null}
  </div>
);

LoaderWithMessage.propTypes = {
  wrapperClassName: PropTypes.string,
  messageClassName: PropTypes.string,
  InnerSpinner: PropTypes.func,
  message: PropTypes.string,
};

LoaderWithMessage.defaultProps = {
  wrapperClassName: '',
  messageClassName: '',
  InnerSpinner: defaultInnerSpinner,
  message: '',
};

export default LoaderWithMessage;
